
import React, { Fragment } from "react";
import _ from 'lodash';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Grid,
  TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {PrimaryButton, SecondaryButton} from 'components/Global/Buttons'
import styled from 'styled-components';
import {
    NoDecimalPercentFormat,
    TwoDecimalPercentFormat,
    ThreeDecimalPercentFormat,
    FourDecimalPercentFormat,
    FiveDecimalPercentFormat,
    FiveDecimalFloatFormat,
    ThreeDecimalFloatFormat,
    TwoDecimalFloatFormat,
    FloatFormat,
    DollarFormat
} from 'components/Notifications/FormattedInputs';
import { states } from "constants/states";
import { AutoCompleteInputAltMargin } from "components/Global/FormikMaterial";
import { ToastError } from "components/Global/Toasts/Toasty";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 20px;
    color: #666;
    min-height: 350px;
  }
`;

const StyledDialog = styled(Dialog)`
&& {
    
}
`

const StyledGridItem = styled(Grid)`
&& {
    width:100%
    margin-bottom:10px
}
`

const StyledTextField = styled(TextField)`
&&{
    width:97%;
}
`

const InstructionalText = styled.span`
&&{
    font-size:14px;
}
`

const StateGridItem = styled(Grid)`
&&{
    
}
`



class RequestNewContactModal extends React.Component {
 
    
    renderTextInput = ({fieldName, doShowPlaceholder, doShowHelperText, value, onChange, width}) => {
        let placeholder = "";
        let helperText = null;
        if(doShowPlaceholder){
            placeholder = fieldName;
        }
        if(doShowHelperText){
            helperText = fieldName;
        }
        let inputProps = {
            disableUnderline:true,
            style:{
                borderBottom: '1px solid #2196F3',    
                transition: '0.3s',
            },
        };
        if(width){
            inputProps.style.width = width;
        }
        let defaultValue = value;
          return(
                <StyledTextField
                    disableUnderline
                    onChange={onChange}
                    defaultValue = {defaultValue}
                    placeholder = {placeholder}
                    label = {helperText}
                    id = {`inputFor ${fieldName}`}
                    InputProps = {inputProps}
                /> 
          )
    }



    render (){
        return (
            <StyledDialog fullWidth={true} open={this.props.modalOpen} id={"requestContactDialog"}>
              <DialogTitle>{"Request New Contact"}</DialogTitle>
              <StyledDialogIconButton onClick={this.props.handleClose}>
                  <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
              </StyledDialogIconButton>
              <StyledDialogContent>
                    <InstructionalText>Fill out the form below to request a new contact.</InstructionalText>
                  <Grid container>
                      <StyledGridItem item xs="6" style={{paddingRight: '20px'}}>{this.renderTextInput({
                          
                            fieldName : "First Name", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.firstName,
                            onChange:(event)=>{this.props.updateScratchContact("firstName",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="6"  style={{paddingRight: '10px'}}>{this.renderTextInput({
                            fieldName : "Last Name", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.lastName,
                            onChange:(event)=>{this.props.updateScratchContact("lastName",event.target.value)},                        
                        })}</StyledGridItem>
                    </Grid>
                    <Grid container>
                        <StyledGridItem item xs="12">{this.renderTextInput({
                            fieldName : "Company", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.company,
                            width:"100%",
                            onChange:(event)=>{this.props.updateScratchContact("company",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="12">{this.renderTextInput({
                            fieldName : "Email", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.email,
                            width:"100%",
                            onChange:(event)=>{this.props.updateScratchContact("email",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="12">{this.renderTextInput({
                            fieldName : "Phone Number", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.phoneNumber,
                            width:"100%",
                            onChange:(event)=>{this.props.updateScratchContact("phoneNumber",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="12">{this.renderTextInput({
                            fieldName : "Address Line 1", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.address1,
                            width:"100%",
                            onChange:(event)=>{this.props.updateScratchContact("address1",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="12">{this.renderTextInput({
                            fieldName : "Address Line 2 (Optional)", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.address2,
                            width:"100%",
                            onChange:(event)=>{this.props.updateScratchContact("address2",event.target.value)},                        
                        })}</StyledGridItem>

                        <StyledGridItem item xs="6" style={{paddingRight: '10px'}}>{this.renderTextInput({
                            fieldName : "City", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.city,
                            onChange:(event)=>{this.props.updateScratchContact("city",event.target.value)},                        
                        })}</StyledGridItem>

                        <StateGridItem item xs="3">
                        <AutoCompleteInputAltMargin    
                            name="state"
                            selectName='name'
                            selectValue='value'
                            fieldName="State"
                            placeholder="State"
                            onChange={(newVal) => {this.props.updateScratchContact("state",newVal.value);}}
                            options={states}/>
                        </StateGridItem>

                        <StyledGridItem item xs="3">{this.renderTextInput({
                            fieldName : "Zip Code", 
                            doShowHelperText:true,
                            value:this.props.scratchContact.zip,
                            width:"90%",
                            onChange:(event)=>{this.props.updateScratchContact("zip",event.target.value)},                        
                        })}</StyledGridItem>
                  </Grid>
              </StyledDialogContent>
              <DialogActions>
                <SecondaryButton id="dialogCancel" onClick={()=>{
                    this.props.handleClose();
                    this.props.updateScratchContact("Clear");
                    }}>{"Cancel"}</SecondaryButton>
                <PrimaryButton id="dialogOK" onClick={()=>{
                    if(this.validateScratchContact()){
                        this.props.handleAccept(this.props.scratchContact);
                        this.props.updateScratchContact("Clear");
                    }
                    }}>{"Send Request"}</PrimaryButton>
              </DialogActions>
            </StyledDialog>);
    }


    validateScratchContact = () => {
        if(this.props.scratchContact){
            let sc = this.props.scratchContact;
            const emailCheck = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            if(sc.firstName && sc.lastName && sc.company && sc.email && sc.phoneNumber && sc.address1 && sc.city && sc.zip && sc.state){
                if(emailCheck.test(sc.email)){
                    return true;
                }else{
                    ToastError("Invalid Email");
                    return false;
                }
            }
        }
        ToastError("All Fields Must Be Filled Out");
        return false;
    }

}
  export default RequestNewContactModal
